module.exports = __webpack_public_path__ + "static-appopensalud/img/primesalud_white.09801fd.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/primesalud_white.svg
// module id = 1100
// module chunks = 120